'use strict';

exports.array = require('./array');
exports.matrix = require('./matrix');



//////////////////
// WEBPACK FOOTER
// ./node_modules/ml-array-utils/node_modules/ml-stat/index.js
// module id = 25
// module chunks = 0